import { render, staticRenderFns } from "./value-propositions.vue?vue&type=template&id=59a7370e&"
import script from "./value-propositions.vue?vue&type=script&lang=js&"
export * from "./value-propositions.vue?vue&type=script&lang=js&"
import style0 from "./value-propositions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports